<div class="pa-input-otp" *ngIf="valueAccessor.control as otpControl">
  <p-inputotp
    #otpContainer
    [formControl]="otpControl"
    [length]="length"
    [invalid]="showInvalid"
    [integerOnly]="true"
  >
    <ng-template pTemplate="input" #input let-token let-events="events">
      <input
        type="tel"
        inputmode="numeric"
        class="p-inputtext p-component p-inputotp-input"
        maxlength="1"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
        data-lpignore="true"
        data-1p-ignore="true"
        [attr.autocomplete]="autocomplete"
        [attr.value]="token || ''"
        [disabled]="isDisabled"
        [class.ng-invalid]="showInvalid"
        [class.ng-dirty]="showInvalid"
        [class.p-invalid]="showInvalid"
        (input)="handleInput($event, events)"
        (keydown)="handleKeyDown($event, events)"
        (beforeinput)="handleBeforeInput($event)"
        (focus)="handleFocus($event)"
        (paste)="events.paste($event)"
      />
    </ng-template>
  </p-inputotp>

  <p *ngIf="displayErrorText" class="error-item" role="alert">
    {{ displayErrorText }}
  </p>
</div>
